// Match — управление матчем: создание состояния, мулиган, цикл фаз, проверка победы.

import { Card } from './card.js';
import { Player } from './player.js';
import { createRng } from './rng.js';
import {
  phaseDraw,
  phaseDrawAnimated,
  runPhase3,
  performHeroAttack,
  playHeroAttackWithAnim,
  endOfTurnCleanup,
  runEndOfTurnTriggers,
  activateStealthUnit,
  getActivatableStealth,
  getStealthTargets,
  NULL_ANIM
} from './phases.js';
// АНИМ.11: diff-snapshot helper для оборачивания sync вызовов с anim.
import { runSyncWithDiff as engine_runSyncWithDiff } from './phases.js';
import {
  tanakiActive, tanakiActiveAvailable,
  nikosiActive, nikosiActiveAvailable,
  sinaActive, sinaActiveAvailable,
  kirosaActive, kirosaActiveAvailable, getKirosaTargets
} from './abilities/deus/index.js';
// Б.3: активки 4 Героев Синтетика.
import {
  bishorActive, bishorActiveAvailable, getBishorActiveTargets,
  riperActive,  riperActiveAvailable,  getRiperActiveTargets,
  rastActive,   rastActiveAvailable,   getRastActiveTargets,
  skvillActive, skvillActiveAvailable, getSkvillActiveTargets
} from './abilities/syntetics/index.js';
// C.1 (промежуточно): активки старых 4 Героев Глобала. Стабы до миграции
// на новые v6 ID (global_mit/iv/li_pul/rayna).
import {
  polkovnikMitActive, polkovnikMitActiveAvailable,
  mayorIvActive, mayorIvActiveAvailable,
  strategLiPulActive, strategLiPulActiveAvailable,
  komissarYarActive, komissarYarActiveAvailable, getKomissarYarActiveTargets
} from './abilities/global/index.js';
// C.1: активки v6-Героев Лив Лайф (ariana/klod/zayn/lisa).
import { arianaActive, arianaActiveAvailable } from './abilities/livlife/c1/ariana.js';
import { klodActive, klodActiveAvailable } from './abilities/livlife/c1/klod.js';
import { zaynActive, zaynActiveAvailable } from './abilities/livlife/c1/zayn.js';
import { lisaActive, lisaActiveAvailable, getLisaActiveDiscardChoices } from './abilities/livlife/c1/lisa.js';
import { onUnitSummoned } from './abilities/deus/hooks.js';
import { fireSyntheticOnSpawnPassive } from './abilities/deus/index.js';
import {
  canPlayInfluenceCard, playInfluenceCard, needsTarget as influenceNeedsTarget, STAND_ORDER,
  rollInfluenceOffer, getInfluencePlayCount, getInfluenceCardTemplates, INFLUENCE_PER_CARD_LIMIT,
  getInfluenceTargets
} from './abilities/deus/influence-cards.js';
import { actionNeedsTarget as deusActionNeedsTarget, getActionTargets as deusGetActionTargets } from './abilities/deus/actions.js';
import { actionNeedsTarget as synActionNeedsTarget, getActionTargets as synGetActionTargets } from './abilities/syntetics/actions.js';
// В.1.a-fix3: заглушки Действий Глобала — карта разыгрывается, эффект пропускается.
import {
  actionNeedsTarget as glbActionNeedsTarget,
  getActionTargets  as glbGetActionTargets
} from './abilities/global/actions.js';
// В.2.a: заглушки Действий Лив Лайф — те же стабы, реализация в В.2.b и далее.
import {
  actionNeedsTarget as livActionNeedsTarget,
  getActionTargets  as livGetActionTargets
} from './abilities/livlife/actions.js';
// C.1 Этап 45: нейтральные Действия (туториал + общие карты).
import {
  actionNeedsTarget as neutralActionNeedsTarget,
  getActionTargets  as neutralGetActionTargets
} from './abilities/neutral/actions.js';
// Этап 56: активка Героя «Лидер улицы» (нейтрал) — реэкспорт для UI/тестов
// (функция была реализована в lider_ulicy.js, но не доступна через match.js).
import {
  liderUlicyActive, liderUlicyActiveAvailable, getLiderUlicyActiveTargets
} from './abilities/neutral/lider_ulicy.js';

export { activateStealthUnit, getActivatableStealth, getStealthTargets };
export { tanakiActive, tanakiActiveAvailable, nikosiActive, nikosiActiveAvailable };
export { sinaActive, sinaActiveAvailable };
export { kirosaActive, kirosaActiveAvailable, getKirosaTargets };
export { liderUlicyActive, liderUlicyActiveAvailable, getLiderUlicyActiveTargets };
// Б.3: активки 4 Героев Синтетика.
export {
  bishorActive, bishorActiveAvailable, getBishorActiveTargets,
  riperActive,  riperActiveAvailable,  getRiperActiveTargets,
  rastActive,   rastActiveAvailable,   getRastActiveTargets,
  skvillActive, skvillActiveAvailable, getSkvillActiveTargets
};
// C.1 (промежуточно): реэкспорт активок старых Героев Глобала.
export {
  polkovnikMitActive, polkovnikMitActiveAvailable,
  mayorIvActive, mayorIvActiveAvailable,
  strategLiPulActive, strategLiPulActiveAvailable,
  komissarYarActive, komissarYarActiveAvailable, getKomissarYarActiveTargets
};
// C.1: реэкспорт активок v6-Героев Лив Лайф.
export {
  arianaActive, arianaActiveAvailable,
  klodActive, klodActiveAvailable,
  zaynActive, zaynActiveAvailable,
  lisaActive, lisaActiveAvailable, getLisaActiveDiscardChoices
};
export {
  rollInfluenceOffer, getInfluencePlayCount, getInfluenceCardTemplates, INFLUENCE_PER_CARD_LIMIT,
  canPlayInfluenceCard, playInfluenceCard, influenceNeedsTarget, STAND_ORDER,
  getInfluenceTargets
};

// C.1: warn о нереализованных способностях для всех фракций (раньше — два
// отдельных файла в global/ и livlife/, теперь общий abilities/warn-unimplemented.js).
import {
  warnUnimplementedGlobalAbilities,
  warnUnimplementedLivLifeAbilities
} from './abilities/warn-unimplemented.js';

// Б.2.b: faction-aware диспетчер для Действий. Раньше match.js экспортировал
// только Деус-диспетчер; теперь по префиксу id (deus_/syn_/glb_) выбираем нужный.
// C.1 Этап 33: v6 ID карт используют префиксы `global_*` и `livlife_*`,
// а старые — `glb_*` и `liv_*`. Раньше диспетчер ловил только старые,
// и v6-Действия Глобала/ЛивЛайфа уходили в default deus → unknown_action.
// Симптом юзера: бот разыгрывал Винтовку GS-7 без проверки целей.
function isSynId(id)     { return typeof id === 'string' && id.startsWith('syn_'); }
function isGlobalId(id)  { return typeof id === 'string' && (id.startsWith('glb_') || id.startsWith('global_')); }
function isLivId(id)     { return typeof id === 'string' && (id.startsWith('liv_') || id.startsWith('livlife_')); }
function isNeutralId(id) { return typeof id === 'string' && id.startsWith('neutral_'); }
export function actionNeedsTarget(cardId) {
  if (isSynId(cardId))     return synActionNeedsTarget(cardId);
  if (isGlobalId(cardId))  return glbActionNeedsTarget(cardId);
  if (isLivId(cardId))     return livActionNeedsTarget(cardId);
  if (isNeutralId(cardId)) return neutralActionNeedsTarget(cardId);
  return deusActionNeedsTarget(cardId);
}
// В.1.h-fix1: реэкспорт минимального хода для Действий (epic=3, legendary=4).
export { actionInitiationTurn } from './phases.js';
// АНИМ.10: реэкспорт diff-snapshot wrapper'а для использования из colyseus
// match-room.ts (handleHeroActive). Снимает before/after-snapshot и проигрывает
// diff'ы heal/buff/summon/damage/death/heroDeath.
export { runSyncWithDiff } from './phases.js';
export function getActionTargets(state, playerIdx, cardId) {
  let raw;
  if (isSynId(cardId)) {
    raw = synGetActionTargets(state, playerIdx, cardId);
  } else if (isGlobalId(cardId)) {
    raw = glbGetActionTargets(state, playerIdx, cardId);
  } else if (isLivId(cardId)) {
    raw = livGetActionTargets(state, playerIdx, cardId);
  } else if (isNeutralId(cardId)) {
    raw = neutralGetActionTargets(state, playerIdx, cardId);
  } else {
    raw = deusGetActionTargets(state, playerIdx, cardId);
  }
  // В.2.e-2: фильтрация untargetable юнитов (Подопытный Альфа). Юнит,
  // у которого `untargetable.byEnemyActions === true`, нельзя выбрать
  // целью Действия ВРАЖЕСКОГО игрока. Свои Действия по нему разрешены.
  // Молчание цели снимает untargetable.
  // В.2.f-2-fix1: дополнительная фильтрация — стелс-юниты ВРАГА «невидимы»
  // для Действий игрока (диздок 6.7). Свои стелс-юниты остаются доступны
  // для своих же Действий.
  if (!Array.isArray(raw)) return raw;
  return raw.filter(u => {
    if (!u) return false;
    // Свой юнит — всегда доступен.
    if (u.ownerId === playerIdx) return true;
    // Вражеский untargetable — исключить (если не Молчание).
    if (u.untargetable?.byEnemyActions === true && !u.current?.silenced) return false;
    // В.2.f-2-fix1: вражеский стелс — невидим для Действий игрока.
    if (u.keywords && u.keywords.includes('stealth')) return false;
    return true;
  });
}
import { canAttackHero } from './combat.js';
import { buildDeckTemplates, getFactionCards } from '../data/decks.js';
import { defaultHero, FORCED_PLAYER_HERO, getHeroes } from '../data/heroes.js';
import { PLAYTEST } from '../data/playtest-config.js';
import { buildRandomDeck } from './deck-builder.js';
import { applySkvillStartingMods } from './abilities/syntetics/skvill-passive.js';
// Б.1.d: импорт регистрационного индекса Синтетика — выполняет registerUnitSummonedExtraHandler.
import './abilities/syntetics/index.js';
// В.1.b: импорт индекса Глобала — выполняет registerHealer для Полевого медика
// и подгружает all common-юнитов В.1.b.
import './abilities/global/index.js';
// В.2.a: импорт индекса Лив Лайф — каркас фракции (warn-unimplemented,
// heal-auras, resurrect). Конкретные карты добавляются в В.2.b и далее.
import './abilities/livlife/index.js';
// C.1 Этап 45: нейтральная фракция (Лидер улицы + 8 карт + Дрон-«муха»).
import './abilities/neutral/index.js';
import {
  initTimings,
  startPhase,
  finishPhase,
  startTurnTimer,
  logTurnSummary,
  logMatchSummary
} from './timing.js';

// Возможные значения state.phase.
export const PHASE = Object.freeze({
  MULLIGAN: 'mulligan',
  DRAW: 'draw',
  PLACEMENT: 'placement',           // оба игрока выбирают карту, UI ждёт игрока
  REVEAL: 'reveal',                 // вскрытие + авто-атаки (выполняются разом)
  HERO_FIRST: 'hero_first',         // атака Героем первого игрока
  HERO_SECOND: 'hero_second',       // атака Героем второго игрока
  END_TURN: 'end_turn',             // очистка, инкремент хода
  GAME_OVER: 'game_over'
});

// Создание матча. seed — для воспроизводимости.
// playerFaction / botFaction — id фракции (по умолчанию обе Deus).
// А.4.5: playerDeck — массив шаблонов из Deck Builder; первые 5 → стартовая рука по порядку,
//        остальные 19 → колода (shuffled). Если null/undefined — старая логика buildDeckTemplates.
//        playerHeroId — id Героя из Deck Builder; если null — defaultHero/PLAYTEST.
//        botRandom — true чтобы бот получил случайного Героя и случайную колоду (UI flow).
//        Если false (или не указано) — старая логика (для headless-тестов).
// Б.1.a: при botRandom=true бот ТАКЖЕ получает случайную фракцию.
//        botFaction в этом случае игнорируется. PLAYTEST.bot.faction перекрывает дефолт.
// Б-1: пул фракций бота расширен до всех 4 (deus / syntetics / global / livlife)
//      — раньше было 50/50 deus/syntetics, что фиксировало бота на двух фракциях
//      против человека и не давало UI-плейтеста за Глобал и Лив Лайф.
const BOT_FACTION_POOL = Object.freeze(['deus', 'syntetics', 'global', 'livlife']);
export function createMatch({
  seed = Date.now(),
  playerName = 'Игрок',
  botName = 'Бот',
  playerFaction = 'deus',
  botFaction = 'deus',
  playerDeck = null,
  botDeck = null,
  playerHeroId = null,
  botHeroId = null,
  botRandom = false,
  // Задача «ошибка вместо фабричной колоды у ИГРОКА»: когда флаг true и
  // реальная колода (playerDeck / botDeck) не пришла или < 24 карт — бросаем
  // ошибку, а НЕ подменяем фабричной buildShuffledDeck. Боты / sandbox /
  // headless-тесты флаг НЕ ставят → фабричная для них сохраняется как раньше.
  strictPlayerDeck = false,
  strictBotDeck = false
} = {}) {
  const rng = createRng(seed);
  const log = createLog();

  // Б.1.a: PLAYTEST.faction (если задан) перекрывает аргумент.
  if (PLAYTEST.enabled && PLAYTEST.player.faction) playerFaction = PLAYTEST.player.faction;
  if (PLAYTEST.enabled && PLAYTEST.bot.faction)    botFaction    = PLAYTEST.bot.faction;
  // Б-1: при botRandom — фракция бота равномерно из всех 4.
  if (botRandom) botFaction = BOT_FACTION_POOL[rng.int(BOT_FACTION_POOL.length)];

  // А.4.5: Герой Игрока — приоритет: playerHeroId → PLAYTEST.forcedHero → FORCED_PLAYER_HERO → default.
  const playerHeroTpl = resolveHero(playerFaction, playerHeroId)
    || resolveHero(playerFaction, PLAYTEST.enabled ? PLAYTEST.player.forcedHero : null)
    || (playerFaction === 'deus' && FORCED_PLAYER_HERO)
    || defaultHero(playerFaction);
  // А.4.5: Бот — botRandom включает случайный Герой; иначе приоритет
  // botHeroId (sandbox: выбранный Герой стороны B) → PLAYTEST.forcedHero → default.
  const botHeroTpl = botRandom
    ? pickRandomHero(botFaction, rng)
    : (resolveHero(botFaction, botHeroId)
      || resolveHero(botFaction, PLAYTEST.enabled ? PLAYTEST.bot.forcedHero : null)
      || defaultHero(botFaction));

  // А.4.5: Колода Игрока — из Deck Builder, иначе фабричная.
  // БУГ.9: раньше первые 5 карт из deck-builder шли в стартовую руку
  // БЕЗ shuffle — игрок всегда получал одни и те же 5 карт. Теперь
  // тасуем всю деку (24 карты) и берём первые 5 как стартовую руку,
  // остальные 19 — в колоду.
  let playerCards;
  let playerHandFromDeck = null;
  // Этап 56-fix: >= 24, не === 24. Синтетик-колода = 24 (лег/эпик/ред/общие) +
  // Моды (rarity 'special', редактор их в лимит 24 не считает) → суммарно 25+.
  // Жёсткое ===24 роняло ЛЮБУЮ синтет-колоду с Модами на фабричную (factory).
  if (playerDeck && playerDeck.length >= 24) {
    const all = playerDeck.map(t => new Card(t));
    rng.shuffle(all);
    playerHandFromDeck = all.slice(0, 5);
    playerCards = all.slice(5);
  } else if (strictPlayerDeck) {
    // Реальная колода игрока не загрузилась — НЕ выдаём фабричную тихо.
    throw new Error(
      `DECK_LOAD_FAILED: реальная колода игрока не загрузилась ` +
      `(получено ${playerDeck ? playerDeck.length + ' карт' : 'ничего'}, нужно ≥24). ` +
      `Фабричная колода игроку не выдаётся.`
    );
  } else {
    playerCards = buildShuffledDeck(rng, playerFaction);
  }
  // А.4.5: Колода Бота — botDeck (PvP: реальная колода 2-го игрока) →
  // botRandom (UI flow PvE) → фабричная по фракции (legacy headless).
  // ПвП.10: botDeck позволяет PvP-серверу передать колоду 2-го игрока
  // тем же путём что и playerDeck — симметрично.
  let botCards;
  let botHandFromDeck = null;
  if (botDeck && botDeck.length >= 24) {   // Этап 56-fix: >=24 (см. playerDeck выше)
    const all = botDeck.map(t => new Card(t));
    rng.shuffle(all);
    botHandFromDeck = all.slice(0, 5);
    botCards = all.slice(5);
  } else if (botRandom) {
    botCards = buildRandomDeck(botFaction, rng).map(t => new Card(t)).reduce((arr, c) => { arr.push(c); return arr; }, []);
    rng.shuffle(botCards);
  } else if (strictBotDeck) {
    // PvP: соперник — реальный игрок, его колода не загрузилась → ошибка,
    // не фабричная (в PvE strictBotDeck=false, бот сохраняет фабричную).
    throw new Error(
      `DECK_LOAD_FAILED: реальная колода соперника не загрузилась ` +
      `(получено ${botDeck ? botDeck.length + ' карт' : 'ничего'}, нужно ≥24).`
    );
  } else {
    botCards = buildShuffledDeck(rng, botFaction);
  }

  const player = new Player(0, playerName, new Card(playerHeroTpl), playerCards);
  const bot = new Player(1, botName, new Card(botHeroTpl), botCards);

  // В.1.a-fix3: предупреждение о пропущенных способностях Героев Глобала.
  // Юниты Глобала получают warning через onUnitSummoned при выставлении.
  warnUnimplementedGlobalAbilities(player.hero);
  warnUnimplementedGlobalAbilities(bot.hero);
  // В.2.a: то же для Лив Лайф — Герои предупреждают о нереализованных
  // способностях сразу. Юниты — при появлении на поле (onUnitSummoned-хук
  // ниже зовёт обе функции).
  warnUnimplementedLivLifeAbilities(player.hero);
  warnUnimplementedLivLifeAbilities(bot.hero);

  // Раздача стартовой руки.
  if (playerHandFromDeck) {
    for (const c of playerHandFromDeck) {
      c.ownerId = player.id;
      player.hand.push(c);
    }
  } else {
    for (let i = 0; i < 5; i++) {
      const a = player.drawOne(); if (a) player.hand.push(a);
    }
  }
  if (botHandFromDeck) {
    for (const c of botHandFromDeck) {
      c.ownerId = bot.id;
      bot.hand.push(c);
    }
  } else {
    for (let i = 0; i < 5; i++) {
      const b = bot.drawOne(); if (b) bot.hand.push(b);
    }
  }

  // Б.1.d: Сквилл passive ч.2 — +2 случайных Мода из колоды в стартовую руку (skvillBonus=true).
  applySkvillStartingMods(player, rng, log);
  applySkvillStartingMods(bot,    rng, log);

  // А.4.4.4: PLAYTEST режим — форс стартовой руки и Влияния.
  if (PLAYTEST.enabled) {
    log.add(`🧪 PLAYTEST режим активен`);
    if (PLAYTEST.player.forcedHand?.length > 0) {
      applyForcedHand(player, PLAYTEST.player.forcedHand, rng);
      log.add(`🧪 Игрок: рука форсирована — ${PLAYTEST.player.forcedHand.join(', ')}`);
    }
    if (PLAYTEST.bot.forcedHand?.length > 0) {
      applyForcedHand(bot, PLAYTEST.bot.forcedHand, rng);
      log.add(`🧪 Бот: рука форсирована — ${PLAYTEST.bot.forcedHand.join(', ')}`);
    }
    if (PLAYTEST.player.forcedInfluence != null) {
      player.influence = Math.max(0, Math.min(10, PLAYTEST.player.forcedInfluence));
      log.add(`🧪 Игрок: стартовое Влияние = ${player.influence}`);
    }
    if (PLAYTEST.bot.forcedInfluence != null) {
      bot.influence = Math.max(0, Math.min(10, PLAYTEST.bot.forcedInfluence));
      log.add(`🧪 Бот: стартовое Влияние = ${bot.influence}`);
    }
  }

  // Монетка — кто ходит первым.
  const firstPlayerIdx = rng.int(2);

  const state = {
    rng,
    log,
    players: [player, bot],
    firstPlayerIdx,
    currentTurn: 1,
    phase: PHASE.MULLIGAN,
    // А.4.4.4: pendingPlacements теперь массив на каждого игрока (extra plays).
    pendingPlacements: [[], []],
    // Б.1.c: Моды, запланированные в Ф2 на раскрытие в Ф3.
    pendingMods: [[], []],
    matchOver: false,
    winnerIdx: null,                 // 0 | 1 | 'draw' | null
    lastBotPlacedId: null,           // instanceId карты бота этого хода (для подсветки)
    lastBotPlacedSlot: null,         // {line, slot} даже если карта умерла в Фазе 3
    // В.1.f-2-B: Рой дронов — отложенная заморозка. Если != null и
    // currentTurn <= swarmFrozenUntilTurn, в этом ходу выполняется ТОЛЬКО Ф1
    // (добор карт), фазы Ф2-Ф6 пропускаются. Триггеры начала хода также
    // пропускаются. Эффект симметричен для обоих игроков.
    swarmFrozenUntilTurn: null
  };
  initTimings(state);

  log.add(`═══ Матч ═══`);
  log.add(`Сид: ${seed} · первым ходит ${state.players[firstPlayerIdx].name}`);
  log.add(`— Мулиган —`);

  return state;
}

// Найти шаблон Героя по id внутри фракции. null, если не найден.
function resolveHero(factionId, heroId) {
  if (!heroId) return null;
  return getHeroes(factionId).find(h => h.id === heroId) || null;
}

// Случайный Герой фракции (для бота в А.4.5 UI flow).
function pickRandomHero(factionId, rng) {
  const heroes = getHeroes(factionId);
  if (!heroes || heroes.length === 0) return defaultHero(factionId);
  return heroes[rng.int(heroes.length)];
}

// Создаёт колоду заданной фракции: экземпляры Card из шаблонов, перемешанные.
function buildShuffledDeck(rng, factionId) {
  const tpls = buildDeckTemplates(factionId);
  const cards = tpls.map(t => new Card(t));
  rng.shuffle(cards);
  return cards;
}

// А.4.4.4: PLAYTEST — заменить стартовую руку списком cardId. Сохраняем размер 5 (или сколько было).
// Не сходящиеся в руку карты ищем в колоде (извлекаем) или создаём из шаблона.
function applyForcedHand(player, cardIds, rng) {
  for (const cardId of cardIds) {
    let target = null;
    const handIdx = player.hand.findIndex(c => c.id === cardId);
    if (handIdx >= 0) continue;             // уже в руке
    const deckIdx = player.deck.findIndex(c => c.id === cardId);
    if (deckIdx >= 0) {
      target = player.deck.splice(deckIdx, 1)[0];
    } else {
      const tpl = getFactionCards(player.hero.faction).find(c => c.id === cardId);
      if (!tpl) {
        // Лог — но не падаем.
        continue;
      }
      target = new Card(tpl);
      target.ownerId = player.id;
      // Компенсация: удаляем случайную карту из колоды (сохраняем баланс ~24).
      if (player.deck.length > 0) {
        player.deck.splice(rng.int(player.deck.length), 1);
      }
    }
    // Если рука переполнена — заменяем случайную карту, заменённая в низ колоды.
    if (player.hand.length >= 5) {
      const swap = rng.int(player.hand.length);
      const replaced = player.hand[swap];
      player.hand[swap] = target;
      player.deck.push(replaced);
    } else {
      player.hand.push(target);
    }
  }
  rng.shuffle(player.deck);
}

// Применить мулиган: indices — индексы карт в руке игрока (idx 0 — игрок снизу).
// Кладём выбранные карты в низ колоды и тянем столько же сверху.
// Б.1.d: бонусные карты Сквилла (skvillBonus=true) НЕ замешиваются — фильтруем индексы.
export function applyMulligan(state, playerIdx, indices) {
  const p = state.players[playerIdx];
  // Фильтр: skvillBonus карты не идут в мулиган.
  indices = indices.filter(i => !p.hand[i]?.skvillBonus);
  if (indices.length > 3) indices = indices.slice(0, 3);
  // Сначала вынем выбранные.
  const chosen = [];
  // Идём по убыванию индекса, чтобы не сдвигались остальные.
  const sorted = [...indices].sort((a, b) => b - a);
  for (const i of sorted) {
    chosen.push(p.hand.splice(i, 1)[0]);
  }
  // В низ колоды.
  for (const c of chosen) p.deck.push(c);
  // Перемешать колоду заново (стандартная практика для мулигана).
  state.rng.shuffle(p.deck);
  // Добрать столько же сверху.
  for (let i = 0; i < chosen.length; i++) {
    const c = p.deck.shift();
    if (c) p.hand.push(c);
  }
  state.log.add(`${p.name} меняет ${chosen.length} карт${pluralRu(chosen.length)} в мулигане`);
}

// Завершить мулиган обоих игроков и стартовать первый ход.
export function finishMulligan(state) {
  state.phase = PHASE.DRAW;
  startTurn(state);
}

// Начало нового хода: лог, переход в фазу Тяги, затем сразу Размещение.
// А.5: state.firstPlayerIdx — единая монетка на матч, используется и в Ф3 (zigzag),
// и в Ф4/Ф5 (порядок Героев). Бросок один раз в createMatch, на каждом ходу одно и то же.
//
// В.1.f-2-B: если ход в окне заморозки (Рой дронов), после Ф1 (только добор)
// сразу выполняется endOfTurnCleanup и переход к следующему ходу — Ф2-Ф6
// пропускаются. Если следующий ход тоже в окне — рекурсивно пропускаем его
// тоже. Окно — максимум 2 хода, переполнения стека нет.
export function startTurn(state) {
  state.log.add(`═══ Ход ${state.currentTurn} ═══`);
  state.log.add(`🪙 Первым атакует ${state.players[state.firstPlayerIdx].name}`);
  state.pendingPlacements = [[], []];
  state.pendingMods = [[], []];                  // Б.1.c
  state.lastBotPlacedId = null;
  state.lastBotPlacedSlot = null;
  for (const p of state.players) {
    p.hero.heroAttackedThisTurn = false;
    p.pendingAction = null;
    // В.1.g-fix2: флаг «уже использовал перемещение Стратега в этой Ф4».
    // Взаимоисключение с heroAttackedThisTurn проверяется в strategApplyMove
    // и в UI-кнопках.
    p.heroMovedUnitThisTurn = false;
  }

  // C.1 Этап 33: roll нового оффера 3 случайных карт Влияния каждому игроку.
  // Только для Деуса (у других фракций нет реализованных карт Влияния в C.1).
  for (let i = 0; i < state.players.length; i++) {
    if (state.players[i].hero?.faction === 'deus') {
      rollInfluenceOffer(state, i);
    } else {
      state.players[i].influenceOffer = [];
    }
  }

  startTurnTimer(state);

  startPhase(state, 1);
  phaseDraw(state);
  finishPhase(state);

  if (checkMatchOver(state)) return;

  // В.1.f-2-B: проверка заморозки от Роя дронов. Ф2-Ф6 пропускаются полностью.
  // endOfTurnCleanup НЕ вызывается — по диздоку Ф6 пропущена → автовосстановления
  // брони и снятия истёкших полос не происходит. Ничего другого в замороженных
  // ходах не накопилось (атак не было, размещений не было).
  if (state.swarmFrozenUntilTurn != null && state.currentTurn <= state.swarmFrozenUntilTurn) {
    state.log.add(
      `⏸ Ход пропущен — Рой дронов (заморозка по ход ${state.swarmFrozenUntilTurn} включительно): ` +
      `только добор карт, фазы 2-6 пропущены`
    );
    logTurnSummary(state, state.currentTurn);
    state.currentTurn += 1;
    // Если заморозка кончилась после инкремента — обнуляем флаг для чистоты state.
    if (state.swarmFrozenUntilTurn != null && state.currentTurn > state.swarmFrozenUntilTurn) {
      state.swarmFrozenUntilTurn = null;
    }
    state.phase = PHASE.DRAW;
    startTurn(state);
    return;
  }

  state.phase = PHASE.PLACEMENT;
  state.log.add(`— Фаза 2: размещение —`);
  // А.4.5-fix2 / Б.1.c: лог бюджета размещений каждому игроку.
  // Синтетикс: +1 если в руке есть Мод (доп.слот ТОЛЬКО под Мод).
  for (let i = 0; i < 2; i++) {
    const p = state.players[i];
    const budget = placementBudget(state, i);
    const extra = p.extraPlaysNextTurn || 0;
    const synSlot = (p.hero.faction === 'syntetics' && p.hand.some(c => c.type === 'mod')) ? 1 : 0;
    state.log.add(`🎯 Ф2 [${p.name}]: бюджет ${budget} размещений (extra=${extra}${synSlot ? ', Мод-слот=1' : ''})`);
  }
  startPhase(state, 2);
}

// АНИМ.10: async-аналог startTurn — phaseDraw обёрнут в anim.diff чтобы
// DoT тики (Кустарный стимулятор) и воскрешения (Второе сердце)
// визуально проигрывались. Sync startTurn остаётся для headless/тестов.
// Используется в colyseus/PvP через runWithAnim из heroAttackOrSkipAnimated.
export async function startTurnAnimated(state, anim = NULL_ANIM) {
  state.log.add(`═══ Ход ${state.currentTurn} ═══`);
  state.log.add(`🪙 Первым атакует ${state.players[state.firstPlayerIdx].name}`);
  // АНИМ.15: phase banner — переход в новый ход (Ф1 Тяга).
  if (typeof anim.phaseBanner === 'function') {
    await anim.phaseBanner(1, `Ход ${state.currentTurn}`);
  }
  state.pendingPlacements = [[], []];
  state.pendingMods = [[], []];
  state.lastBotPlacedId = null;
  state.lastBotPlacedSlot = null;
  for (const p of state.players) {
    p.hero.heroAttackedThisTurn = false;
    p.pendingAction = null;
    p.heroMovedUnitThisTurn = false;
  }

  for (let i = 0; i < state.players.length; i++) {
    if (state.players[i].hero?.faction === 'deus') {
      rollInfluenceOffer(state, i);
    } else {
      state.players[i].influenceOffer = [];
    }
  }

  startTurnTimer(state);

  startPhase(state, 1);
  await phaseDrawAnimated(state, anim);
  finishPhase(state);

  if (checkMatchOver(state)) return;

  // Рой дронов: ход с заморозкой пропускает Ф2-Ф6.
  if (state.swarmFrozenUntilTurn != null && state.currentTurn <= state.swarmFrozenUntilTurn) {
    state.log.add(
      `⏸ Ход пропущен — Рой дронов (заморозка по ход ${state.swarmFrozenUntilTurn} включительно): ` +
      `только добор карт, фазы 2-6 пропущены`
    );
    logTurnSummary(state, state.currentTurn);
    state.currentTurn += 1;
    if (state.swarmFrozenUntilTurn != null && state.currentTurn > state.swarmFrozenUntilTurn) {
      state.swarmFrozenUntilTurn = null;
    }
    state.phase = PHASE.DRAW;
    await startTurnAnimated(state, anim);
    return;
  }

  state.phase = PHASE.PLACEMENT;
  state.log.add(`— Фаза 2: размещение —`);
  for (let i = 0; i < 2; i++) {
    const p = state.players[i];
    const budget = placementBudget(state, i);
    const extra = p.extraPlaysNextTurn || 0;
    const synSlot = (p.hero.faction === 'syntetics' && p.hand.some(c => c.type === 'mod')) ? 1 : 0;
    state.log.add(`🎯 Ф2 [${p.name}]: бюджет ${budget} размещений (extra=${extra}${synSlot ? ', Мод-слот=1' : ''})`);
  }
  startPhase(state, 2);
}

// Записать ожидающую выкладку игрока.
// payload: { cardInstanceId, line, slot, targetInstanceId? } или null (сбросить все).
// Б.1.c: для Мода (type='mod') line/slot не нужны, но требуется targetInstanceId.
//        Mod не уходит на поле, а лежит в очереди и обрабатывается в Ф3 (revealPendingMods).
// А.4.4.4: поддерживает несколько размещений (extra plays). null — сброс массива.
export function setPendingPlacement(state, playerIdx, payload) {
  if (payload === null) {
    state.pendingPlacements[playerIdx] = [];
    return;
  }
  state.pendingPlacements[playerIdx].push(payload);
}

// Б.2.c-fix2: отменить одну запланированную выкладку. Если отменяется ОСНОВНАЯ
// карта (Юнит/Действие), Моды этого же игрока тоже снимаются — нельзя оставлять
// «Мод запланирован, основной карты нет». Возвращает true, если что-то снялось.
export function cancelPendingPlacement(state, playerIdx, cardInstanceId) {
  const arr = state.pendingPlacements[playerIdx] || [];
  const i = arr.findIndex(pl => pl.cardInstanceId === cardInstanceId);
  if (i === -1) return false;
  const removedPayload = arr.splice(i, 1)[0];
  const hand = state.players[playerIdx].hand;
  const removedCard = hand.find(c => c.instanceId === cardInstanceId);
  // Если убрали основную — снимаем все Моды у этого игрока.
  if (removedCard && (removedCard.type === 'unit' || removedCard.type === 'action')) {
    state.pendingPlacements[playerIdx] = arr.filter(pl => {
      const c = hand.find(h => h.instanceId === pl.cardInstanceId);
      return c?.type !== 'mod';
    });
  }
  return true;
}

// Б.1.c: сколько слотов размещения доступно у игрока в этом ходу.
//   Базовый: 1.
//   + extraPlaysNextTurn (Деус: Аудитор/Совет/Интендант).
//   + 1 если игрок Синтетикс И в руке есть хотя бы один Мод (type='mod').
//     Этот доп.слот может быть занят ТОЛЬКО Модом — см. canAddPlacement.
// Б.2.d: при активном эффекте Инициатора у Синтетика лимит «1 Мод» снят —
//   доп.слотов столько же, сколько Модов в руке.
export function placementBudget(state, playerIdx) {
  const p = state.players[playerIdx];
  let budget = 1 + (p.extraPlaysNextTurn || 0);
  if (p.hero.faction === 'syntetics') {
    const modCount = p.hand.filter(c => c.type === 'mod').length;
    if (modCount > 0) {
      const initiatorActive = !!(p.activeInitiatorEffect && p.activeInitiatorEffect.remainingTurns > 0);
      budget += initiatorActive ? modCount : 1;
    }
  }
  return budget;
}

// Сколько уже размещено в этой Ф2.
export function placementsUsed(state, playerIdx) {
  return state.pendingPlacements[playerIdx]?.length || 0;
}

// Б.1.c / Б.1.d-fix1: можно ли ещё разместить эту карту с учётом правил Синтетикса
// (юнит/действие + Мод; не два юнита/Действия, не два Мода).
// Деус: бюджет 1 + extraPlaysNextTurn — любой тип в каждый слот, без ограничений по типу.
// Возвращает {ok, reason?}.
//
// Б.2.c-fix2: Мод можно играть ТОЛЬКО в дополнение к основной карте (Юнит/Действие)
// этого же хода. Без основной — reason='mod_requires_main'.
export function canAddPlacement(state, playerIdx, card) {
  const p = state.players[playerIdx];
  const used = state.pendingPlacements[playerIdx] || [];
  const budget = placementBudget(state, playerIdx);
  // Б.2.d-fix4: Действие живёт в p.pendingAction (а не в pendingPlacements),
  // но по диздоку 6.4 любая разыгранная карта (Юнит/Действие) занимает один слот
  // бюджета. Считаем суммарный расход: pendingPlacements + pendingAction.
  const usedSlots = used.length + (p.pendingAction != null ? 1 : 0);
  if (usedSlots >= budget) return { ok: false, reason: 'budget_exhausted' };
  // Поиск типов уже размещённых карт.
  const usedTypes = used.map(pl => {
    const c = p.hand.find(h => h.instanceId === pl.cardInstanceId);
    return c?.type || null;
  });
  const isSyn = p.hero?.faction === 'syntetics';
  if (card.type === 'mod') {
    // Моды — только у Синтетика; не больше одного за ход.
    if (!isSyn) return { ok: false, reason: 'wrong_faction' };
    // Б.2.d: при активном Инициаторе лимит «1 Мод за ход» снят.
    const initiatorActive = !!(p.activeInitiatorEffect && p.activeInitiatorEffect.remainingTurns > 0);
    if (!initiatorActive && usedTypes.includes('mod')) {
      return { ok: false, reason: 'one_mod_per_turn' };
    }
    // Б.2.c-fix2: запрет одиночного Мода — нужна основная карта в этом ходу.
    // Основная: pendingPlacements содержит unit, или p.pendingAction != null.
    const hasMain = usedTypes.some(t => t === 'unit' || t === 'action')
                  || (p.pendingAction != null);
    if (!hasMain) return { ok: false, reason: 'mod_requires_main' };
    return { ok: true };
  }
  if (card.type === 'unit' || card.type === 'action') {
    // У Синтетика — не больше одного юнита/Действия за ход (Мод-слот — только под Мод).
    // У Деуса — любой тип; ограничение только бюджет (extraPlaysNextTurn).
    //
    // Б.2.b-fix1 (Баг 4): pendingAction живёт ОТДЕЛЬНО от pendingPlacements
    // (см. main.js → setPendingPlacement vs me.pendingAction). До фикса
    // usedTypes не учитывал pendingAction — Синтетик мог сыграть Действие+Юнит
    // (или Действие+Действие) в один ход. Теперь pendingAction учитывается
    // как «уже сыграна основная карта» и блокирует ещё одну.
    const hasMainPlay = usedTypes.some(t => t === 'unit' || t === 'action')
                     || (p.pendingAction != null);
    if (isSyn && hasMainPlay) {
      return { ok: false, reason: 'one_unit_or_action_per_turn' };
    }
    return { ok: true };
  }
  return { ok: false, reason: 'wrong_card_type' };
}

// Б.1.c-fix2: есть ли у игрока ещё доступные размещения в этой Ф2?
// Pure-функция, тестируемая. Возвращает { canPlaceNonMod, canPlaceMod, anyAvailable }.
//   - canPlaceNonMod: можно сыграть ещё юнит/Действие.
//   - canPlaceMod: можно сыграть Мод (Синтетикс).
// Учитывает pending-юнитов как валидные цели Мода (свежевыставленный — тоже свой юнит).
export function getAvailablePlacements(state, playerIdx) {
  const p = state.players[playerIdx];
  const used = state.pendingPlacements[playerIdx] || [];
  const budget = placementBudget(state, playerIdx);
  // Б.2.d-fix4: учёт pendingAction в израсходованных слотах.
  const usedSlots = used.length + (p.pendingAction != null ? 1 : 0);
  const usedTypes = used.map(pl => {
    const c = p.hand.find(h => h.instanceId === pl.cardInstanceId);
    return c?.type || null;
  });
  const hasNonMod = usedTypes.some(t => t === 'unit' || t === 'action') || (p.pendingAction != null);
  const hasMod = usedTypes.includes('mod');
  const isSyn = p.hero.faction === 'syntetics';
  let canPlaceNonMod = false;
  if (usedSlots < budget && (!isSyn || !hasNonMod)) {
    if (p.hasFreeSlot() && p.hand.some(c => c.type === 'unit')) canPlaceNonMod = true;
    if (p.hand.some(c => c.type === 'action') && !p.pendingAction) canPlaceNonMod = true;
  }
  let canPlaceMod = false;
  // Б.2.d: при активном Инициаторе hasMod (уже сыграли Мод) НЕ блокирует.
  const initiatorActive = isSyn && !!(p.activeInitiatorEffect && p.activeInitiatorEffect.remainingTurns > 0);
  const modLimitFree = initiatorActive ? false : hasMod;
  if (isSyn && usedSlots < budget && !modLimitFree && p.hand.some(c => c.type === 'mod')) {
    // Б.1.c-fix2: цель Мода — любой свой юнит на поле или pending этого хода.
    const ownOnField = p.unitsOnField().length > 0;
    const pendingHasUnit = used.some(pl => {
      const c = p.hand.find(h => h.instanceId === pl.cardInstanceId);
      return c?.type === 'unit';
    });
    // Б.2.c-fix2: Мод требует основную карту (Юнит ИЛИ Действие) в этом же ходу.
    const hasMain = pendingHasUnit || (p.pendingAction != null);
    const hasAnyTarget = ownOnField || pendingHasUnit;
    if (hasMain && hasAnyTarget) canPlaceMod = true;
  }
  return {
    canPlaceNonMod, canPlaceMod,
    anyAvailable: canPlaceNonMod || canPlaceMod
  };
}

// Применить ожидающие выкладки обоих игроков (одновременно), затем — async Фаза 3 с анимацией.
// anim — объект-аниматор (ui/anim.js или NULL_ANIM из phases.js для headless).
export async function commitPlacementsAndReveal(state, anim = NULL_ANIM) {
  // Закрываем таймер Фазы 2 (он шёл от "— Фаза 2: размещение —" до сейчас).
  finishPhase(state);
  // Б.1.c: очередь Модов на раскрытие в Ф3.
  if (!state.pendingMods) state.pendingMods = [[], []];
  // Б.2.b-fix1 (Баг 4): server-side guard — если у Синтетика прорвалось через UI
  // комбо «Действие + Юнит/Действие», бракуем последнюю основную карту в
  // pendingPlacements (возвращается в руку) и оставляем pendingAction в силе.
  // canAddPlacement теперь это блокирует, но guard страхует от рассинхрона.
  for (let i = 0; i < 2; i++) {
    const p = state.players[i];
    if (p.hero?.faction !== 'syntetics') continue;
    if (p.pendingAction == null) continue;
    const placements = state.pendingPlacements[i] || [];
    const filtered = [];
    for (const pay of placements) {
      const card = p.hand.find(h => h.instanceId === pay.cardInstanceId);
      if (card && (card.type === 'unit' || card.type === 'action')) {
        state.log.add(
          `⚠ Синтетик [${p.name}]: одновременная основная и Действие — ` +
          `"${card.name_ru}" отброшена, остаётся в руке (баг лимита Ф2)`
        );
        continue;
      }
      filtered.push(pay);
    }
    state.pendingPlacements[i] = filtered;
  }
  for (let i = 0; i < 2; i++) {
    const placements = state.pendingPlacements[i] || [];
    const p = state.players[i];
    for (const pay of placements) {
      const idx = p.hand.findIndex(c => c.instanceId === pay.cardInstanceId);
      if (idx === -1) continue;
      const card = p.hand.splice(idx, 1)[0];
      // Б.1.c: Моды откладываются в pendingMods и раскрываются в Ф3.
      if (card.type === 'mod') {
        state.pendingMods[i].push({
          card,
          targetInstanceId: pay.targetInstanceId ?? null,
          ownerIdx: i
        });
        continue;
      }
      if (card.type !== 'unit') {
        p.discard.push(card);
        state.log.add(`${p.name}: карта "${card.name_ru}" типа ${card.type} не размещается на поле, уходит в сброс`);
        continue;
      }
      if (p.field[pay.line][pay.slot] !== null) {
        p.hand.push(card);
        state.log.add(`${p.name}: слот ${pay.line}/${pay.slot} занят, выкладка отменена`);
        continue;
      }
      card.placedTurn = state.currentTurn;
      card.revealed = false;
      p.placeCard(card, pay.line, pay.slot);
      // АНИМ.16: card placement — ghost карты летит из руки в slot.
      // Зовём ДО onUnitSummoned чтобы анимация шла перед триггерами.
      if (typeof anim.cardPlacement === 'function') {
        await anim.cardPlacement(card, pay.line, pay.slot, i);
      }
      // Запоминаем последнюю карту бота этого хода — для подсветки в начале Фазы 4.
      if (i === 1) {
        state.lastBotPlacedId = card.instanceId;
        state.lastBotPlacedSlot = { line: card.line, slot: card.slot };
      }
      state.log.add(`↓ ${p.name} разместил карту на ${pay.line === 0 ? '1-ю' : '2-ю'} линию (слот ${pay.slot + 1})`);
      // А.4.4.3: триггер появления союзного юнита (Ликвидатор-эксперт, аура Второго директора).
      onUnitSummoned(state, i, card);
      // Б.2.d: spawn-passive Синтетика (Личный телохранитель, Инициатор) —
      // только если юнит НЕ в Режиме ожидания. Спящие отработают в onTurnStart
      // в момент пробуждения.
      if (!card.isSleeping(state.currentTurn) && !card.spawnPassiveFired) {
        fireSyntheticOnSpawnPassive(state, i, card);
        card.spawnPassiveFired = true;
      }
    }
    // А.4.4.4: extraPlays использованы — сбрасываем счётчик.
    p.extraPlaysNextTurn = 0;
  }
  state.phase = PHASE.REVEAL;
  startPhase(state, 3);
  await runPhase3(state, anim);
  finishPhase(state);
  if (checkMatchOver(state)) return;

  state.phase = PHASE.HERO_FIRST;
  state.log.add(`— Фаза 4: герой 1 —`);
  startPhase(state, 4);
}

// Применить атаку Героя текущего активного игрока.
// target — Card | null (null = пропустить).
//
// ВАЖНО (В.1.c-2-fix1, БАГ 1): эта функция всегда ПРОДВИГАЕТ фазу — это
// «удар + переход дальше». Используется ботом и тестами как «закончить ход
// Героя». Игроку через UI её вызывают только при явном Pass'е (target=null),
// чтобы Ф4/Ф5 не обрывалась после первого удара. Для одиночного удара без
// перехода — performHeroAttackKeepPhase ниже.
export function heroAttackOrSkip(state, target) {
  const idx = state.phase === PHASE.HERO_FIRST ? state.firstPlayerIdx : 1 - state.firstPlayerIdx;
  if (target) {
    performHeroAttack(state, idx, target);
    if (checkMatchOver(state)) return;
  } else {
    state.log.add(`${state.players[idx].name}: герой пропускает атаку`);
  }
  // Переход к следующей фазе атаки или к концу хода.
  if (state.phase === PHASE.HERO_FIRST) {
    finishPhase(state);                  // закрываем таймер Фазы 4
    state.phase = PHASE.HERO_SECOND;
    state.log.add(`— Фаза 5: герой 2 —`);
    startPhase(state, 5);
  } else {
    finishPhase(state);                  // закрываем таймер Фазы 5
    // А.4.4.1: триггеры конца хода (Кироса, Аудитор...) — до cleanup'а.
    runEndOfTurnTriggers(state);
    logTurnSummary(state, state.currentTurn);
    endOfTurnCleanup(state);
    state.currentTurn += 1;
    state.phase = PHASE.DRAW;
    startTurn(state);
  }
}

// В.1.c-2-fix1 (БАГ 1): атака Героя БЕЗ продвижения фазы.
// Используется UI: после удара игрок должен иметь возможность активировать
// Скрытных юнитов в той же Ф4/Ф5. Фаза продвигается только по явному Pass'у
// (UI вызывает heroAttackOrSkip(state, null)) или по истечению таймера.
// Возвращает true, если атака была выполнена; false — если цель невалидна.
export function performHeroAttackKeepPhase(state, target) {
  if (!target) return false;
  const idx = state.phase === PHASE.HERO_FIRST ? state.firstPlayerIdx : 1 - state.firstPlayerIdx;
  const ok = performHeroAttack(state, idx, target);
  // checkMatchOver вызывается отдельно вызывающим (UI делает rerender).
  return !!ok;
}

// БОЙ.1.9: async-обёртки с анимацией. Sync-функции выше — для тестов
// и legacy-кода (vanilla UI, playtest-инструменты), новые async-версии —
// для React-клиента и PvP-сервера.

export async function heroAttackOrSkipAnimated(state, target, anim = NULL_ANIM) {
  const idx = state.phase === PHASE.HERO_FIRST ? state.firstPlayerIdx : 1 - state.firstPlayerIdx;
  if (target) {
    await playHeroAttackWithAnim(state, idx, target, anim);
    if (checkMatchOver(state)) return;
  } else {
    state.log.add(`${state.players[idx].name}: герой пропускает атаку`);
  }
  if (state.phase === PHASE.HERO_FIRST) {
    finishPhase(state);
    state.phase = PHASE.HERO_SECOND;
    state.log.add(`— Фаза 5: герой 2 —`);
    startPhase(state, 5);
    // АНИМ.15: phase banner — переход к атаке второго Героя.
    if (typeof anim.phaseBanner === 'function') {
      await anim.phaseBanner(5, 'Герой 2');
    }
  } else {
    finishPhase(state);
    // АНИМ.11: EOT триггеры и cleanup могут менять поле (копия Торчка
    // через onEndOfTurn, истечение временных бонусов в endOfTurnCleanup
    // — потеря брони/атаки). Оборачиваем в diff-snapshot чтобы видеть.
    await engine_runSyncWithDiff(state, anim, (s) => {
      runEndOfTurnTriggers(s);
    });
    logTurnSummary(state, state.currentTurn);
    await engine_runSyncWithDiff(state, anim, (s) => {
      endOfTurnCleanup(s);
    });
    state.currentTurn += 1;
    state.phase = PHASE.DRAW;
    // АНИМ.10: startTurnAnimated вместо sync startTurn — DoT/воскрешения
    // в новой Ф1 будут проигрывать diff'ы heal/buff/damage/summon.
    await startTurnAnimated(state, anim);
  }
}

export async function performHeroAttackKeepPhaseAnimated(state, target, anim = NULL_ANIM) {
  if (!target) return false;
  const idx = state.phase === PHASE.HERO_FIRST ? state.firstPlayerIdx : 1 - state.firstPlayerIdx;
  const ok = await playHeroAttackWithAnim(state, idx, target, anim);
  return !!ok;
}

// Проверка завершения матча. Если оба Героя ≤0 — ничья.
export function checkMatchOver(state) {
  const [p1, p2] = state.players;
  const dead1 = p1.hero.hp <= 0;
  const dead2 = p2.hero.hp <= 0;
  if (dead1 && dead2) {
    state.matchOver = true;
    state.winnerIdx = 'draw';
    state.phase = PHASE.GAME_OVER;
    state.log.add(`💀 Ничья — оба Героя пали`);
    finishPhase(state);
    logMatchSummary(state);
    return true;
  }
  if (dead1) {
    state.matchOver = true;
    state.winnerIdx = 1;
    state.phase = PHASE.GAME_OVER;
    state.log.add(`🏆 Победа: ${state.players[1].name}`);
    finishPhase(state);
    logMatchSummary(state);
    return true;
  }
  if (dead2) {
    state.matchOver = true;
    state.winnerIdx = 0;
    state.phase = PHASE.GAME_OVER;
    state.log.add(`🏆 Победа: ${state.players[0].name}`);
    finishPhase(state);
    logMatchSummary(state);
    return true;
  }
  return false;
}

// Простой лог матча.
function createLog() {
  const entries = [];
  const listeners = new Set();
  return {
    entries,
    add(msg) {
      entries.push(msg);
      for (const l of listeners) l(msg);
    },
    onAdd(fn) { listeners.add(fn); return () => listeners.delete(fn); }
  };
}

// Вспомогательное склонение карта/карты/карт для русского.
function pluralRu(n) {
  const n10 = n % 10, n100 = n % 100;
  if (n10 === 1 && n100 !== 11) return 'у';
  if ([2, 3, 4].includes(n10) && ![12, 13, 14].includes(n100)) return 'ы';
  return '';
}
